import Icon from "@/ui/Icon";
import { FOOTER_LINKS, X_URL } from "@/lib/constants";
import { format } from "date-fns";
import usePathWithSlug from "@/hooks/usePathWithSlug";

const currentYear = format(new Date(), "yyyy");

const Footer = () => {
  const pathWithSlug = usePathWithSlug();

  return (
    <footer
      className="border-t border-[#2B2D31] px-[5%] py-[3rem] lg:py-[4.5rem] xl:py-[5rem]"
      role="contentinfo"
      aria-label="Site footer"
    >
      <div className="mx-auto flex w-full max-w-[1440px] flex-col">
        <div className="flex w-full flex-col items-center justify-between gap-[3rem] pb-[3rem] md:flex-row lg:pb-[4.5rem] xl:pb-[5rem]">
          <section className="flex items-center" aria-labelledby="footer-logo">
            <h2 id="footer-logo" className="sr-only">
              Thrive Protocol
            </h2>
            <a href={pathWithSlug("/")} aria-label="Return to Thrive Protocol homepage">
              <Icon name="logo" className="h-[4rem] w-[10rem]" />
            </a>
          </section>

          <section className="flex items-center gap-3" aria-labelledby="footer-social">
            <h2 id="footer-social" className="sr-only">
              Follow Us
            </h2>
            <a href={X_URL} target="_blank" aria-label="Follow us on X (Twitter)">
              <Icon name="twitter" />
            </a>
          </section>
        </div>

        <div className="mx-auto w-full border-t border-[#2B2D3160] pb-8" />

        <div className="flex w-full flex-col items-center justify-center gap-4 md:flex-row">
          <div className="text-center sm:text-right">
            <p
              className="text-sm font-normal text-[#8f8f8f]"
              role="text"
              aria-label={`Copyright ${currentYear} Thrive Protocol. All rights reserved.`}
            >
              © {currentYear} Thrive Protocol.
            </p>
          </div>
          <nav className="flex flex-col gap-4 text-center md:flex-row lg:gap-6" aria-label="Legal and policy links">
            {FOOTER_LINKS.map((link) => (
              <a
                key={link.text}
                href={link.href}
                target={link.external ? "_blank" : "_self"}
                rel={link.external ? "noopener noreferrer" : undefined}
                title={link.description}
                className="text-sm font-normal leading-tight text-[#8f8f8f] underline underline-offset-2 transition-colors hover:text-white focus:text-white focus:outline-none"
              >
                {link.text}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
